'use strict';

import Common from "../../Utils/Common";

/**
 * @classname ChangeCartQuantity
 * @classdesc カート数量変更
 */
export default class ChangeCartQuantity {
	/**
	 * @constructor
	 * @param {jQuery} $e - .block__item--cart-quantity .input-select__select
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._stockId = $e.closest('.list__item').attr('data-stock-id');
		this._controller = controller;
		$e.on('change', () => this.onChange());
		//this._controller.on('onReCalculateCartComplete', () => this.setNewAmount());
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeCartQuantity
	 * @return undefined
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`);
		const quantity = this._$e.val();
		this._controller.ChangeCartQuantity(this._stockId, quantity);
	};


	/**
	 * 金額設定
	 *
	 * @memberof ChangeCartQuantity
	 * @return undefined
	 */
	/*setNewAmount() {
		console.log(`${this.constructor.name}.setPrice`);
		if(this._stockId !== this._controller._itemStockId) return;
		// 小計の更新
		const price = parseInt(this._$e.attr('data-price'));
		const quantity = parseInt(this._$e.val());
		const subtotal = price * quantity;
		this._$e.closest('.block').find('strong').text(Common.separatedByComma(subtotal));
		// 合計の更新
		const res = this._controller._data;
		console.log(res);
		const $area = this._$e.closest('.area--cart');
		$area.find('.total_item_amount').text(`¥${Common.separatedByComma(res.total_item_amount)}`);
		$area.find('.total_tax1').text(`¥${Common.separatedByComma(res.total_tax1)}`);
		$area.find('.total_tax2').text(`¥${Common.separatedByComma(res.total_tax2)}`);
		$area.find('.shipping_fee').text(`¥${Common.separatedByComma(res.shipping_fee)}`);
		$area.find('.total_billing_amount').text(`¥${Common.separatedByComma(res.total_billing_amount)}`);
	};*/
};
